var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.22 14.78C5.36063 14.9205 5.55125 14.9994 5.75 14.9994C5.94875 14.9994 6.13937 14.9205 6.28 14.78L13.5 7.56005V13.25C13.5 13.449 13.579 13.6397 13.7197 13.7804C13.8603 13.921 14.0511 14 14.25 14C14.4489 14 14.6397 13.921 14.7803 13.7804C14.921 13.6397 15 13.449 15 13.25V5.75005C15 5.33605 14.664 5.00005 14.25 5.00005H6.75C6.55109 5.00005 6.36032 5.07907 6.21967 5.21972C6.07902 5.36037 6 5.55114 6 5.75005C6 5.94896 6.07902 6.13973 6.21967 6.28038C6.36032 6.42103 6.55109 6.50005 6.75 6.50005H12.44L5.22 13.72C5.07955 13.8607 5.00066 14.0513 5.00066 14.25C5.00066 14.4488 5.07955 14.6394 5.22 14.78Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteArrowIcon);
export default __webpack_public_path__ + "static/media/whiteArrowIcon.916097c8389c4daeacfd69b21eba1af0.svg";
export { ForwardRef as ReactComponent };